import { useContext, useState } from "react";
import toast from "react-hot-toast";
import { AppContext } from "../../scripts/context";
import StakeButton from "../StakeButton";
import Style from "./style";
import MetaMaskActions from "../MetaMaskActions";
import NFTStatusMobile from "../NFTStatusMobile";

export default function StakedDetails() {
  const {
    state,
    state: {
      contracts: {
        staking: {
          contract: stakingContract,
          data: { stakedDetails },
        },
      },
    },
    updateStakeholderData,
    getStakingList,
    setState,
  } = useContext(AppContext);
  const [isUnStaking, setIsUnStaking] = useState(false);

  const unStakeLp = async () => {
    setIsUnStaking(true);

    try {
      const result = await stakingContract.unstakeLPToken();

      toast.promise(
        result.wait().then(async () => {
          const stakeholderData_ = await updateStakeholderData(stakingContract);
          const transactions = await getStakingList();

          setState({
            contracts: {
              ...state.contracts,
              staking: {
                ...state.contracts.staking,
                data: {
                  ...state.contracts.staking.data,
                  stakedDetails: stakeholderData_,
                  transactionsList: transactions,
                },
              },
            },
          });

          setIsUnStaking(false);
        }),
        {
          loading: "Loading...",
          success: "Success!",
          error: (error) => error.message,
        }
      );
    } catch (error) {
      toast.error("We are sorry, something went wrong.");
      console.log(error);
      setIsUnStaking(false);
    }
  };

  return (
    <>
      <Style>
        <div className="status-details-container">
          <div>
            <div className="status-details border-bottom">
              <span>Locked LPs ($BULT/TFUEL)</span>
              <h3>{stakedDetails.lockedLPs}</h3>
            </div>
            <div className="status-details border-bottom">
              <span>Total LPs ($BULT/TFUEL)</span>
              <h3>{stakedDetails.totalLPs}</h3>
            </div>
            <div className="status-details">
              <span>Next Unlock</span>
              <h3>{stakedDetails.nextUlocke}</h3>
            </div>
          </div>

          <div>
            <div className="status-box">
              <div className="lock-icon">
                <img src="img/lock-icon.svg" alt="lock-icon" />
              </div>
              <div>
                <span>Unlocked LPs ($BULT/TFUEL)</span>
                <h3>{stakedDetails.unlockedLPs}</h3>
              </div>
            </div>
            <div className="status-box">
              <div className="lock-icon">
                <img src="img/lock-icon.svg" alt="lock-icon" />
              </div>
              <div>
                <span>Unlocked Rewards ($BULT)</span>
                <h3>{stakedDetails.unlocekdRewards}</h3>
              </div>
            </div>
            <div className="status-box">
              <div className="lock-icon">
                <img src="img/lock-icon.svg" alt="lock-icon" />
              </div>
              <div>
                <span>NFT Unlocked Date</span>
                <h3>{stakedDetails.nftUnlockedDate}</h3>
              </div>
            </div>
          </div>
        </div>
        <div className="progress-bar-container">
          <div className="progress-bar">
            <div
              style={{
                width: `${
                  (stakedDetails.unlockedLPs / stakedDetails.totalLPs) * 100
                }%`,
              }}
            />
          </div>
          <span>
            {(
              (stakedDetails.unlockedLPs / stakedDetails.totalLPs) *
              100
            ).toFixed(4)}
            %
          </span>
        </div>

        <div className="footer-actions">
          <div>
            {/* <StakeButton
              onClick={() => {
                setState({
                  contracts: {
                    ...state.contracts,
                    staking: {
                      ...state.contracts.staking,
                      data: {
                        ...state.contracts.staking.data,
                        stakeAgain: true,
                      },
                    },
                  },
                });
              }}
              text="Stake LP"
            /> */}
            <button
              className="un-stake"
              onClick={unStakeLp}
              disabled={
                isUnStaking ||
                !state.contracts.staking.data.transactionsList.some(
                  (tx) => tx.status === "Unlocked"
                )
              }
            >
              Unstake LPs {"&"} Rewards {isUnStaking ? "..." : ""}
            </button>
          </div>
          <div>
            <MetaMaskActions />
          </div>
        </div>
      </Style>
      <NFTStatusMobile />
    </>
  );
}
